module.exports = __webpack_public_path__ + "static/media/home_mobile.26d6e2e6.png";